/**
 * The HOC component is used to process report raw data to cater for display requirements
 * @author: Ronan
 */
import React, { PureComponent } from 'react';
import Enums from 'utils/EnumsManager';

const { REPORTS, DROPZONES } = Enums;
const { TOTALROWKEY, GROUPROWKEY } = REPORTS.PREVIEW;
const { GROUPS, OTHERS, AGGREGATES } = DROPZONES;

const processData = () => WrappedComponent =>
  class extends PureComponent {
    // Get keys from data that will display in group row, i.e. fields w/ avg, sum, total
    getKeysDisplayInGroup = data => {
      if (!_.isArray(data) || data.length < 1) {
        return [];
      }
      const keys = Object.keys(data[0]);
      const displayableKeys = ['__avg', '__sum', 'total'];
      // TODO: could be a performance issue, due to O(m * n)
      return keys.filter(k => displayableKeys.some(dk => k.indexOf(dk) > -1));
    };

    // Generate full data
    getGroupsData = (groups, records, settings) => {
      const me = this;

      const groupKey = me.getGroupKey(settings);

      const groupsData = groups.reduce((data, group) => {
        const groupData = me.getGroupData(group, records, groupKey);
        // Change for lookup field group row, because the value is an Object
        if (groupData[1]) {
          const rowField = groupData[1][groupKey];
          // If it's lookup field
          if (_.isPlainObject(rowField)) {
            const key = Object.keys(rowField).filter(k => k !== 'id')[0];
            if (key) {
              groupData[0][groupKey] = rowField;
            }
          }
        }
        return [...data, ...groupData];
      }, []);

      return groupsData;
    };
    // Generate data by group
    getGroupData = (group, records, groupKey) => {
      if (_.isEmpty(group) || _.isEmpty(records)) {
        return [];
      }
      // Notes: if group is not required, group name is null
      const groupName = group[groupKey] ? group[groupKey] : '';
      const groupRecords = _.isArray(records[groupName])
        ? records[groupName]
        : [];
      const summaryRecord = {
        ...group,
        [GROUPROWKEY]: true
      };
      return [summaryRecord, ...groupRecords];
    };
    // Get group field name
    getGroupKey = settings => {
      if (_.isEmpty(settings) || _.isEmpty(settings[GROUPS])) {
        return '';
      }
      const group = settings[GROUPS][0];
      if (!group) {
        return '';
      }
      if (group.type) {
        return `${group.field_name}__${group.type}`;
      }
      return group.field_name ? group.field_name : '';
    };

    render() {
      const { groups, records, settings, total } = this.props;

      const groupsData = this.getGroupsData(groups, records, settings);
      const processedData = [...groupsData, { ...total, [TOTALROWKEY]: true }];
      return <WrappedComponent {...this.props} processedData={processedData} />;
    }
  };

export default processData;



// WEBPACK FOOTER //
// ./src/views/RealTimeReport_Table/components/processData.jsx